import React from "react";

interface ISecureFieldProps {
  fieldType: "card" | "expiry" | "cvc" | "cvv";
  label: string;
  customClass?: string;
  callback: () => void;
  children?: React.ReactNode;
}

export default function SecureField({
  fieldType,
  label,
  customClass,
  callback,
  children,
}: ISecureFieldProps) {
  return (
    <div
      id={fieldType + "-number-container"}
      className={`c-form__element c-form__element--active ${customClass}`}
      onClick={() => callback()}
    >
      <label htmlFor={fieldType + "-number"}>{label}</label>
      <div className="flex items-center gap-2 bg-white rounded-md p-2 mt-1 h-10 border border-custom-400">
        <div className="secure-field--input" id={fieldType + "-number"}></div>
        <div className="relative">{children}</div>
      </div>
    </div>
  );
}
